module.exports = __webpack_public_path__ + "img/logomark.5a3f4d4b.png";